import React from 'react';
import SectionHeader from './SectionHeader';
import CurrencyInput from './CurrencyInput';
import NotesInput from './NotesInput';

/**
 * Section 9 — Kids & Education
 */
export default function StepKidsEducation({ data = {}, onChange }) {
  function set(field, value) {
    onChange({ ...data, [field]: value });
  }

  const fields = [
    { key: 'child_support', label: 'Child Support' },
    { key: 'books_school_supplies', label: 'Books & School Supplies' },
    { key: 'clothing_toys_supplies', label: 'Clothing, Toys & Other Supplies' },
    { key: 'daycare_childcare_sitters', label: 'Day Care / Child Care / Sitters' },
    { key: 'k12_tuition', label: 'K-12 Education / Tuition' },
    { key: 'college_tuition', label: 'College Tuition' },
  ];

  const total = fields.reduce(
    (sum, f) => sum + (Number(data[f.key]) || 0),
    0
  );

  return (
    <div>
      <SectionHeader
        number={9}
        title="Kids & Education"
        tip="No children or children all grown up? Feel free to skip this section — just click Nothing to enter."
      />

      <div className="alert alert-light border small mb-4">
        <strong>Note:</strong> Education Savings (529s, etc.) are captured in
        the Savings section.
      </div>

      <div className="cashflow-field-grid">
        {fields.map(({ key, label }) => (
          <CurrencyInput
            key={key}
            id={key}
            label={label}
            value={data[key] ?? null}
            onChange={(val) => set(key, val)}
          />
        ))}
      </div>

      {total > 0 && (
        <div className="cashflow-total-box mt-3">
          <span className="fw-semibold">9: Total Kids & Education</span>
          <span className="cashflow-total-amount">
            ${total.toLocaleString(undefined, { minimumFractionDigits: 0, maximumFractionDigits: 0 })}
          </span>
        </div>
      )}

      <NotesInput value={data.notes} onChange={(val) => set('notes', val)} />
    </div>
  );
}
